import React, { useState, useEffect } from 'react';

// Store
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { logout } from 'src/store/auth/slice';

// UI
import { BaseDivider, BaseTypography } from 'src/components/common';
import MenuIcon from '@material-ui/icons/Menu';
import { useDeviceSizeType } from 'src/utils/hooks/useDeviceType';
import { APP_ROUTES } from 'src/routing/AppRoutes';
import { AppNotifications } from './notifications/AppNotifications';
import defaultImg from 'src/assets/images/no-user-picture.svg';
import { useStyles } from './styles';
import { useStyles as useMenuStyles } from '../styles';
import { InterviewsNotifications } from './notifications/InterviewNotifications';

// Utils
import { IUser } from 'src/api/base/Auth/types';
import { getUserHomePage } from 'src/utils/helpers';
import faqIcon from '../assets/icons/faq-ico.svg';
import blogIcon from '../assets/icons/blog-ico.svg';
import eventIcon from '../assets/icons/event-ico.png';
import { NavHeaderLink } from '../components/NavHeaderLink';
import { Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

function getUserName(user?: IUser) {
  return (
    user &&
    user.profile &&
    `${user.profile.first_name} ${user.profile.last_name}`
  );
}

const MemoizedAppNotifications = React.memo(AppNotifications);

export const AuthorizedMenu: React.FC<any> = () => {
  const classes = useStyles();
  const menuClasses = useMenuStyles();
  const { user } = useSelector((state: RootState) => state.auth);

  const dispatch = useDispatch();
  const history = useHistory();
  
  
  const eventsClick = (event: React.MouseEvent<HTMLElement>) => {
	  history.push(`${APP_ROUTES.EVENTS_NEW}?tab=posts`);
	  window.location.reload(); 
	  /* if(user) {
		  history.push(`${APP_ROUTES.EVENTS_NEW}?tab=posts`);
		  window.location.reload(); 
	  }else {
		  dispatch(openLoginModal("Expert"));
	  } */
  }


  const userNameDom = (
    <div>
      <BaseTypography className={classes.userName}>
        {getUserName(user!)}
      </BaseTypography>
      <BaseTypography className={classes.userEmail}>
        ({user?.email})
      </BaseTypography>
    </div>
  );
	
  const blogElDom = (
    <NavHeaderLink to={APP_ROUTES.ALLPOSTS} title="Blog" img={blogIcon} alt="BLOG POST" />
  );

  const eventsnewElDom = (
    <div style={{color: 'black', cursor: 'pointer', display: 'flex', alignItems: 'center'}} className={classes.menu__link} onClick={eventsClick}>
		<img style={{marginRight: '11px'}} src={eventIcon} alt="Story ideas" className={classes.menuIco} />
		<span>Story ideas</span>
	</div>
  );

  const faqElDom = (
    <NavHeaderLink to={APP_ROUTES.FAQ} title="FAQ" img={faqIcon} alt="FAQ" />
  );

  const userProfile = (
    <div
      className={classes.userProfile}
      onClick={() => history.push(getUserHomePage(user!))}>
      <img
        className={classes.userImg}
        src={user?.avatar || defaultImg}
        alt="avatar"
      />
      {userNameDom}
    </div>
  );

  const { isMobile } = useDeviceSizeType();

  const handleLogout = () => {
    dispatch(logout());
    history.push(APP_ROUTES.MAIN);
	window.location.reload(); 
  };
  const logoutBtn = (
    <Button
      variant="contained"
      color= "primary"
      className={classes.logOut}
      onClick={handleLogout}>
      Log out
    </Button>
  );

  const [menuOpen, setMenuOpen] = useState([
    {
      val: "profile",
      active: false,
      menuList:[userProfile, logoutBtn]
    },
    {
      val: "menu",
      active: false,
      menuList:[faqElDom, blogElDom, eventsnewElDom]
    }
  ]);

  const openmenuActive = (obj:any) =>{
    const updateArr = menuOpen.filter((x:any)=> {
      if(x.val === obj){
        x.active = !x.active
      }else{
        x.active = false
      }
      return x
    })
    setMenuOpen(updateArr)
  }

  const closeMenu = () => {
    const updateMenu = menuOpen.filter((x:any)=> {x.active = false; return x});
    setMenuOpen(updateMenu)
  }

  const profileImg = (
    <div
      className={classes.userProfile}
      onClick={() => openmenuActive("profile")}
      >
      <img
        className={classes.userImg}
        src={user?.avatar || defaultImg}
        alt="avatar"
      />
    </div>
  )

  const mobile = (
    <>
      <div className={classes.mobileHeaderRow}>
        {/* {faqElDom} */}
        <InterviewsNotifications />
       <div
          style={{
            width: '30px',
            height: '30px',
          }}>
          <MemoizedAppNotifications />
       </div>
        {profileImg}
        {menuOpen[1].active ? <CloseIcon onClick={() => openmenuActive("menu")} />: <MenuIcon  onClick={() => openmenuActive("menu")}/>}
      </div>

      {menuOpen?.map((item:any)=>(
      <div
        className={`${menuClasses.menu__list} ${menuClasses.menu__mobileMenu} ${
          item.active && menuClasses.menu__mobileMenu_active
        }`}>
          {item.menuList.map((list:any)=>(
            <>{list}</>
          ))}
      </div>
      ))}
    </>
  );

  const desktop = (
    <div className={classes.rootDesktop}>
	  <div style={{ marginRight: '25px', alignSelf: 'center' }}>{blogElDom}</div>
    <div style={{ marginRight: '25px', alignSelf: 'center' }}>{eventsnewElDom}</div>
      <div style={{ marginRight: '25px', alignSelf: 'center' }}>{faqElDom}</div>
      <div style={{ marginRight: '25px', alignSelf: 'center' }}>
        <InterviewsNotifications />
      </div>
      <div
        style={{
          marginRight: '25px',
          width: '30px',
          height: '30px',
          alignSelf: 'center',
        }}>
        <MemoizedAppNotifications />
      </div>
      {userProfile}
      <BaseDivider orientation="vertical" />
      {logoutBtn}
    </div>
  );

  useEffect(() => {
    const onScroll = (e:any) => {      
      if(e.target.documentElement.scrollTop > 100){
        closeMenu()
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return !isMobile ? desktop : mobile;
};
